<template>
  <div class="container-loading" v-if="!size">
    <div v-if="message" class="header" :style="fontColor ? `color:${fontColor}`:''"><div class="text">{{message}}</div></div>
    <div class="lds-dual-ring"></div>
  </div>
  <div class="container-loading" v-else>
    <div v-if="message" class="header small" :style="fontColor ? `color:${fontColor}`:''"><div class="text">{{message}}</div></div>
    <div class="lds-dual-ring small"></div>
  </div>
</template>

<script>
export default {
  props: ["message","fontColor","size"]
};
</script>

<style lang="scss" scoped>
.container-loading {
  display: inline-flex;
}
.header {
  font-size: 25px;
  margin-right: 20px;
  .text {
    line-height: 80px;
  }
}
.header.small {
  font-size: 12.5px;
  margin-right: 10px;
  .text {
    line-height: 40px;
  }
}
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring.small{
  width: 40px;
  height: 40px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid var(--primary);
  border-color: var(--primary) transparent var(--primary) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
.lds-dual-ring.small:after{
  width: 32px;
  height: 32px;
  margin: 4px;
  border: 3px solid var(--primary);
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>